import styled from "@emotion/styled";
import React, { useContext, useState, useEffect } from "react";
import { Box } from "@mui/system";
import ProfileContext from "../../context/ProfileContext";
import StaffContext from "../../context/StaffContext";
import { Tab, Tabs } from "@mui/material";
import { useTheme } from "@emotion/react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import RequireAuth from "../../components/RequireAuth";
import Constants from "../400/constants";
import useAuth from "../../hooks/useAuth";
import StaffStatus from "./StaffStatus";
import AddStatus from "./AddStatus";
import EditStatus from "./EditStatus";
import ResearchSettings from "../../components/800/ResearchSettings";
import HourSetting from "../300/HourSetting";
import CourseContext from "../../context/CourseContext";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import RegisterRank from "../700/RegisterRank";
import RankManagment from "../700/RankManagement";
import EditRank from "../700/EditRank";
export default function SystemSettings() {
  const api = useAxiosPrivate();
  const navigate = useNavigate();
  const InfoWrapper = styled(Box)({
    width: "100%",
    marginLeft: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  });
  const { state } = useContext(ProfileContext);
  const courseContext = useContext(CourseContext);
  const details = state.details;
  const HandleChange = (event, newValue) => {
    setTable(newValue);
    navigate(newValue);
  };
  const { user } = useAuth();
  const roles = user?.roles;
  //   if(window.location.pathname==='/staff_agreements')
  //   {
  //     navigate(roles.includes(106)?"/staff_agreements/staff_overload":"/staff_agreements/part_time")
  //   };
  const [table, setTable] = useState(window.location.pathname);
  useEffect(() => {
    api
      .get("constant/hourSetting")
      .then((res) => {
        console.log(res.data.hours);
        courseContext.setHours({ ...res.data.hours });
        //setInit(res.data.hours);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <>
      <InfoWrapper>
        <Tabs
          value={table}
          onChange={HandleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
          sx={{
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            margin: "10px",
          }}
        >
          {roles?.includes(1100) && (
            <Tab value="/system_setting" label="Semester Settings" />
          )}
          {roles?.includes(1101) && (
            <Tab value="/system_setting/research_role" label="Research Role" />
          )}
          {roles?.includes(1102) && (
            <Tab value="/system_setting/rank" label="Academic Ranks" />
          )}
          {roles?.includes(1103) && (
            <Tab value="/system_setting/status" label="Staff Status" />
          )}
          {roles?.includes(1103) && (
            <Tab value="/system_setting/hour" label="Hour Setting" />
          )}
        </Tabs>
        <Routes>
          <Route element={<RequireAuth allowedRoles={[1101]} />}>
            <Route exact path="/research_role" element={<ResearchSettings />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[1100]} />}>
            <Route exact path="/" element={<Constants />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[1103]} />}>
            <Route exact path="/status" element={<StaffStatus />} />
          </Route>{" "}
          <Route element={<RequireAuth allowedRoles={[1103]} />}>
            <Route exact path="/hour" element={<HourSetting />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[1103]} />}>
            <Route exact path="/status/addStatus" element={<AddStatus />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={[1103]} />}>
            <Route exact path="/status/editStatus" element={<EditStatus />} />
          </Route>
          <Route path="rank">
            <Route element={<RequireAuth allowedRoles={[302]} />}>
              <Route index element={<RankManagment />} />
            </Route>
            <Route element={<RequireAuth allowedRoles={[303]} />}>
              <Route path="addRank" element={<RegisterRank />} />
            </Route>
            <Route element={<RequireAuth allowedRoles={[303]} />}>
              <Route path="editRank" element={<EditRank />} />
            </Route>
          </Route>
        </Routes>
      </InfoWrapper>
    </>
  );
}
